import React, {useEffect} from 'react';
import styled from "styled-components";
import {UserContext} from "@providers/user";
import Badges from "@atoms/badges";
import Icon from "@atoms/icon";
import PlusIcon from '@icons/plus.svg';
import PropertyRegisterIcon from '@icons/menu/menu-add.svg';
import ChevronLeftIcon from "@icons/chevron-left.svg";
import {useWindowSize} from "@helpers/windows.size";
import {isEmpty} from "@helpers/helpers";

export default function PropertyCreateButton(props) {
    const windowSize = useWindowSize();
    const userContext = React.useContext(UserContext);

    useEffect(() => {
        const handlePropertyCreateClick = (e) => {
            // Google Tag Manager Custom Event Trigger for Property Create Button Click
            console.log('on-navbar-by' + (userContext.isRealtor ? '-realtor' : '-owner') + '-create-property');
            if (!isEmpty(window.dataLayer)) {
                window.dataLayer.push({
                    'event': 'on-navbar-by' + (userContext.isRealtor ? '-realtor' : '-owner') + '-create-property',
                });
            }
        };

        document.getElementById('btnRegister').addEventListener('click', handlePropertyCreateClick);
        document.getElementById('btnRegister2').addEventListener('click', handlePropertyCreateClick);

        return () => document.getElementById('btnRegister').removeEventListener('click', handlePropertyCreateClick)
        return () => document.getElementById('btnRegister2').removeEventListener('click', handlePropertyCreateClick)
    }, []);

    return (
        <PropertyCreate className={props.className ? props.className : ''}>
            <a id={props.id} href="/ثبت/ملک" className={"btn btn-sm btn-create-property " + ((process.browser && window.innerWidth < 992) ? '' : 'btn-primary')}>
                <div className="d-flex align-items-center">
                    <Icon className="d-block d-lg-none right-icon"><PropertyRegisterIcon/></Icon>
                    <Icon className="d-none d-lg-flex plus-icon ml-8 right-icon"><PlusIcon/></Icon>

                    <span>
                    <span className="d-none d-lg-inline-block">ثبت آگهی رایگان</span>
                    <span className="d-inline-block d-lg-none">ثبت آگهی</span>
                    <Badges color="secondary" className="mr-8 d-lg-none">رایگان</Badges>
                </span>
                </div>

                <Icon height={16} width={16} className="d-none left-caret-icons mr-8 "><ChevronLeftIcon/></Icon>
            </a>
        </PropertyCreate>
    )
}

// styles
export const PropertyCreate = styled.div`
    .icons.right-icon {
        width: 24px;
        max-width: 24px;
        height: 24px;
        
        &.plus-icon {
            width: 12px;
            max-width: 12px;
            height: 12px;          
        }
        //margin-left: 8px;
        color: #ffffff;
        border-color: #ffffff;
        
        svg {
          path {
            stroke :#ffffff;
          }
        }
    }
`;